var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9937",
    "data-name": "Group 9937",
    transform: "translate(18573 2474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    className: "cls-1",
    d: "M22.2,43.226H10.7V27.848a.731.731,0,0,1,.426-.7L13.8,25.913V22.467a.715.715,0,0,1,.426-.658L26.57,15.577c.039-.039.039-.039.077-.039a.135.135,0,0,1,.077-.039h.31a.135.135,0,0,0,.077.039c.039.039.039.039.077.039l5.342,2.71a.715.715,0,0,1,.426.658v3.368l3.2-.8c.039,0,4.543,2.886,4.543,2.886V43.226H31.631",
    transform: "translate(-18582.699 -2488.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    className: "cls-2",
    d: "M-22923.705-20446.361v-21.467",
    transform: "translate(4377.173 18001.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    className: "cls-2",
    d: "M-22923.705-20441.125v-19.609",
    transform: "translate(4360.063 17995.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    className: "cls-2",
    d: "M-22923.705-20437.166v-23.576",
    transform: "translate(4367.805 17987.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    className: "cls-2",
    d: "M-22927.756-20466.562v20.912",
    transform: "translate(4378.03 18000.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    "data-name": "Path 7376",
    className: "cls-1",
    d: "M-22977.391-20460.773l5.219-2.266,4.34.264v15.279",
    transform: "translate(4408.451 17998.156)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1828",
    "data-name": "Ellipse 1828",
    className: "cls-3",
    cx: 2.357,
    cy: 2.357,
    r: 2.357,
    transform: "translate(-18558.285 -2447.714)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteProject);
export default __webpack_public_path__ + "static/media/CompleteProject.8ab1ae7980dad639e34a8a69b16b9bc6.svg";
export { ForwardRef as ReactComponent };